import React, { useContext, useEffect, useState } from 'react'
import styled, { css, keyframes } from 'styled-components'
import { QuizContext } from '../context/QuizContext'
import QuizCard from './QuizCard'
import bigSmiley from '../img/emojis/bigsmiley.svg'
import star from '../img/emojis/starface.svg'
import heartEyes from '../img/emojis/hearteyes.svg'
import cool from '../img/emojis/cool.svg'
import oops from '../img/emojis/oops.svg'
import blush from '../img/emojis/blush.svg'
import omg from '../img/emojis/omg.svg'
import _, { set } from 'lodash'

const correctEmojis = [bigSmiley, star, cool, heartEyes]
const wrongEmojis = [oops, blush, omg]

const wrongAnimation = keyframes`
0% { transform: translate(0,0);}
20% { transform: translate(-20px,0); }
60% { transform: translate(20px,0); }
100% { transform: translate(0px,-10px); }
`
const mirroredWrongAnimation = keyframes`
0% { transform: translate(0,0);}
20% { transform: translate(-20px,0); }
60% { transform: translate(20px,0); }
100% { transform: translate(0px,10px); }
`

const correctAnimation = keyframes`
0% { filter: hue-rotate(0deg); }
50% { transform: translate(0,-50px);}
100% { filter: hue-rotate(360deg); }
`
const mirroredCorrectAnimation = keyframes`
0% { transform: translate(0,0);}
100% { transform: translate(0px,10px); }
`


const WiggleWrapper = styled.div`
  transform-style: preserve-3d;
  backface-visibility: hidden;
  z-index:1;
  &.wrong {
    z-index:-1;
    ${props => props.question ? css`
      animation: ${wrongAnimation} 0.2s linear 2;
    ` : css `
      animation: ${mirroredWrongAnimation} 0.2s linear 2 reverse;
    `}
  }
  &.correct {
    z-index:-1;
    ${props => props.question ? css`
      animation: ${correctAnimation} 1s linear 1;
    ` : css `
      animation: ${correctAnimation} 1s linear 1;
    `}
  }
`

const FloatingCard = styled.div`
  
  transform-style: preserve-3d;
  
  * {
    transform-style: preserve-3d;
    backface-visibility: hidden;
  }

  ${props => props.animating && css`
    .selected {
      box-shadow: none !important;
    }
  `}

  &.align {
    transform: translate(
      ${props => props.transform.x}px,
      ${props => props.transform.y}px
    ) 
    translateZ(500px) 
    scale(${props => props.transform.scale});
    transition: all 0.5s;
  }
  &.rotate {
    transform:  translate(
      ${props => props.transform.x}px,
      ${props => props.transform.y}px
    )
    translateZ(500px)
    scale(${props => props.transform.scale}) 
    rotateY(180deg);
    transition: all 0.75s;
  }
  &.wrong, &.correct {
    transform:  translate(
      ${props => props.transform.x}px,
      ${props => props.transform.y}px
    )
    scale(${props => props.transform.scale}) 
    rotateY(180deg);
    transition: all 0.75s;
  }

  img {
    width:100%;
  }
`

const BackImage = styled.img`
  position:absolute;
  top:50%;
  left:0;
  transform: rotateZ(${props => props.rot}deg) rotateY(180deg);
  backface-visibility: hidden;
`

const QuizAnimation = ({animating, data, question, ...props}) => {

  const [destinationTransform, setDestinationTransform] = useState({x:0,y:0,scale:1})
  const {questionElement, answerElement, questionInfo, answerInfo, questionType} = data
  const [animationStep, setAnimationStep] = useState()
  const [emoji, setEmoji] = useState()
  const {playCorrectSound, playWrongSound, updateScoreCounter} = useContext(QuizContext)

  useEffect(() => {
    if (animating) {
      const qrect = questionElement.current.getBoundingClientRect()
      const arect = answerElement.getBoundingClientRect()
      
      if (question) {
        const scale = arect.width / qrect.width
        const deltaScale = arect.width - qrect.width
        setDestinationTransform({
          x: arect.left - qrect.left + deltaScale/2,
          y: arect.top - qrect.bottom - deltaScale/2,
          scale: arect.width / qrect.width,
        })
      } else {
        setDestinationTransform({
          x: 0,
          y: 0,
          scale: 1,
        })
      }

      //setAnimationStep()
      setTimeout(() => {
        setAnimationStep('align')
      }, 200)
      setTimeout(() => {
        setAnimationStep('rotate')
        updateScoreCounter(data.correct)
      }, 800)
      setTimeout(() => {
        setAnimationStep('align')
      }, 2000)
      // setTimeout(() => {
      //   if (!data.correct) {
      //     setAnimationStep('wrong')
      //     //playWrongSound()
      //   } else {
      //     //playCorrectSound()
      //     setAnimationStep('correct')
      //   }
      // }, 1400)
    } else {
      setAnimationStep()
    }
  }, [animating])

  useEffect(() => {
    setEmoji(_.sample(data.correct ? correctEmojis : wrongEmojis))
  }, [data.correct])

  return (
    <WiggleWrapper question={question} className={animationStep}>
      <FloatingCard animating={animating} transform={destinationTransform} className={animationStep}>
      {props.children}
      {animating && question && <BackImage rot={0} src={emoji} />}
      {/* {animating && question && <BackImage rot={-90} src={require(`../img/${questionInfo.imgBack}`).default} />}
      {animating && !question && <BackImage rot={-90} src={require(`../img/${answerInfo.exampleBack}`).default} />} */}
      </FloatingCard>
    </WiggleWrapper>
  )
  // return (
  //   <>
  //     <FloatingCard rect={qrect} destRect={drect} className={animationStep}>
  //       <QuizCard cardData={questionInfo} questionType={questionType} question />
  //     </FloatingCard>
  //     <FloatingCard rect={arect} destRect={arect} className={animationStep}>
  //       <QuizCard cardData={answerInfo} questionType={questionType} />
  //     </FloatingCard>
  //   </>
  // )
}

QuizAnimation.defaultProps = {
  data: {}
}

export default QuizAnimation
